import { Component } from 'utils';
import { baseLoadingSelector ,selectedProjectsSelector, selectedGroupsSelector ,somethingLoadingSelector} from './selectors/base';
import { editModeSelector, gridSelector, settingsSelector, loadingSelector,dummyGridSelector } from './selectors/settings';

@Component({
    template: require('./newDashboard.tpl.html')
})
export class NewDashboardComponent {
    static $inject = ['$uibModal','SettingsActions', 'DataActions', 'SelectedActions', 'EnvironmentTypesActions', 'TimePeriodsActions', '$ngRedux', '$q', '$sce','$element','$timeout','$window','$scope'];

    constructor($uibModal, SettingsActions, DataActions, SelectedActions, EnvironmentTypesActions, TimePeriodsActions, $ngRedux, $q, $sce,$element,$timeout,$window,$scope) {
        'ngInject';
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$q = $q;
        this.$element = $element;
        this.unsubscribe = $ngRedux.connect(mapStateToThis, {
            ...SettingsActions,
            ...DataActions,
            ...SelectedActions,
            ...EnvironmentTypesActions,
            ...TimePeriodsActions,
            ...EnvironmentTypesActions
        })(this);
        this.cellWidth = 0;
        this.dummyWidth = 0;
        this.itemMap = {
            sizeX: 'item.size.x',
            sizeY: 'item.size.y',
            row: 'item.position.row',
            col: 'item.position.column',
            allowResize: 'item.resizing.enabled',
            minSizeX: 'item.resizing.x.min',
            minSizeY: 'item.resizing.y.min',
            maxSizeX: 'item.resizing.x.max',
            maxSizeY: 'item.resizing.y.max'
        };
        this.$timeout = $timeout;
        this.$scope.$watch(() => $window.innerWidth, () => {
            const gridsterWidth = $element.find('.dbm-dashboard > .wrapper').width();
            this.cellWidth = gridsterWidth / 8; // count of columns
            this.dummyWidth = gridsterWidth - 20; // padding
        });
    }

    get dummyGridOptions() {
        return {
            ...this.gridOptions,
            draggable: { enabled: false },
            resizable: { enabled: false },
            cellWidth: this.cellWidth
        };
    }

    get gridOptions() {
        return {
            columns: 8,
            floating: true,
            swapping: false,
            mobileModeEnabled: false,
            rowHeight: 150,
            width: this.dummyWidth,
            colWidth: this.cellWidth,
            margin: [0, 0],
            minRows: 1,
            resizable: {
                enabled: this.editMode,
                stop: () => {
                    const settings = this.settings;
                    this.grid.forEach(item => {
                        settings[item.widget].position = {
                            row: item.position.row,
                            column: item.position.column
                        };
                        if (item.resizing.enabled) {
                            settings[item.widget].size = {
                                width: item.size.x,
                                height: item.size.y
                            }
                        }
                    });
                    this.saveChanges(settings, true);
                }
            },
            draggable: {
                enabled: this.editMode,
                stop: () => {
                    const settings = this.settings;
                    this.grid.forEach(item => {
                        settings[item.widget].position = {
                            row: item.position.row,
                            column: item.position.column
                        };
                    });
                    this.saveChanges(settings, true);
                }
            }
        };
    }

    $onInit() {
        this.focusedItem = 0;
        this.loadSettings();
        this.$q.all([
            this.loadData(),
            this.loadSelected()
        ]).then(() => {
            this.loadEnvironmentTypes({ projectIds: this.projectIds, groupIds: this.groupIds });
        });
        this.loadTimePeriods();
    }

    $onDestroy() {
        this.unsubscribe();
    }

    focus(index) {
        this.focusedItem = index;
    }

    openLibrary() {
        if (!this.baseLoading && this.editMode) {
            this.$uibModal.open({
                appendTo: this.$element.find('.dbm-dashboard'),
                component: 'dbmWidgetsLibrary',
                size: 'lg',
                backdrop: 'static'
            });
        }
    }

    removeFromDashboard(widget) {
        switch (widget) {
            case 'main':
                this.settings.main.total.visible = false;
                this.settings.main.successful.visible = false;
                this.settings.main.failed.visible = false;
                this.settings.main.meanTime.visible = false;
                this.settings.main.deploymentDuration.visible = false;
                this.settings.main.failedRatio.visible = false;
                break;
            case 'deploymentFrequency':
                this.settings.deploymentFrequency.display = 'none';
                break;
            case 'leadTime':
                this.settings.leadTime.display = 'none';
                break;
            case 'changeVolume':
                this.settings.changeVolume.display = 'none';
                break;
            case 'activities':
                this.settings.acitivities.visible = false;
                break;
            default:
                return;
        }
        this.grid.splice(this.gridOptions.findIndex(g => g.widget === widget), 1);
    }

    setDisplayType(widget, display) {
        if (!['all', 'graph', 'summary'].some(d => d === display)) {
            return;
        }
        switch (widget) {
            case 'deploymentFrequency':
                this.settings.deploymentFrequency.display = display
                break;
            case 'leadTime':
                this.settings.changeVolume.display = display;
                break;
            case 'changeVolume':
                this.settings.changeVolume.display = display;
                break;
            default:
                return;
        }
    }

    applyEditModeChanges() {
        this.saveChanges(this.settings);
    }
}

function mapStateToThis(state) {
    const obj = {
        baseLoading: baseLoadingSelector(state),
        editMode: editModeSelector(state),
        settings: settingsSelector(state),
        grid: gridSelector(state),
        loading: somethingLoadingSelector(state),
        projectIds: selectedProjectsSelector(state),
        groupIds: selectedGroupsSelector(state),
        dummyGrid: dummyGridSelector(state)
    };
    return obj;
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/newDashboard.js